export default __webpack_public_path__ + "static/media/truckRojevasMobile.1e0712b5.jpg";